import React from "react";
import { useStaffAuth } from "../../context/StaffAuthContext";
import Breadcrumb from "../../components/hub/Breadcrumb";
import HubSection from "../../components/hub/HubSection";

import { hubReportCardLinks } from "../../data/hub/hubReportCardLinks";

/**
 * Report Card hub. One component mounted at two routes in App.js:
 *   owner: /report-cards              -> <ReportCardHub isPortal={false} />
 *   staff: /staff-panel/report-cards  -> <ReportCardHub isPortal={true} />
 *
 * Detail pages:
 *   /report-cards/batches
 *   /report-cards/grade-schemes
 *   /report-cards/templates
 *   /report-cards/batches/:id
 *   /report-cards/cards/:id
 *
 * Manage actions stay in-page via hasPermission("REPORT_CARD_FULL").
 *
 * Icon styling is handled centrally by HubGrid -> HubIcon.
 */
const ReportCardHub = ({ isPortal = false }) => {
  const { hasPermission } = useStaffAuth();

  return (
    <div className="min-h-screen bg-neutral-50/50 dark:bg-neutral-950 py-6 sm:py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-6">

        {/* Header & Breadcrumb */}
        <div className="space-y-2">
          <Breadcrumb
            items={[{ label: "Report Cards" }]}
            homeUrl={isPortal ? "/staff-home" : "/school-home"}
          />

          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 pt-1 border-b border-neutral-200 dark:border-neutral-800/80 pb-4">
            <div>
              <h1 className="text-xl sm:text-2xl font-bold tracking-tight text-neutral-900 dark:text-neutral-100">
                Report Cards
              </h1>

              <p className="text-xs font-semibold text-neutral-500 dark:text-neutral-400 mt-0.5">
                Generate, publish and print student report cards from submitted marks.
              </p>
            </div>
          </div>
        </div>

        {/* Navigation Section Cards */}
        <div className="space-y-6">
          {hubReportCardLinks.map((section) => (
            <HubSection
              key={section.sectionTitle}
              title={section.sectionTitle}
              icon={section.sectionIcon}
              links={section.links}
              isPortal={isPortal}
              basePath="/staff-panel"
              hasPermission={hasPermission}
            />
          ))}
        </div>

      </div>
    </div>
  );
};

export default ReportCardHub;